export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/82a41b02157d-tooliconlocationpin.jpg',
  },
  title: 'Which airports did you use?',
  departureTitle: 'Your departure airport',
  arrivalTitle: 'Your arrival airport',
}
